import { useContext, useEffect, useRef, useState } from "react";
// import Client from "shopify-buy";
// import Client from 'shopify-buy/index.unoptimized.umd';
import ProductsHome from "./components/ProductsHome";
import VsMasonry from "./components/VsMansory";
import { fetchWebsiteProducts, fetchWebsiteProductsByCat, fetchWebsiteCollections } from "./utils/api";
import Filters from "./components/Filters";
import { Context as FilterContext } from './context/FilterContext'
import { Backdrop, CircularProgress } from "@mui/material";
import { isMobile } from "react-device-detect";
import MobileFilters from "./components/mobile/MobileFilters";
import MobileMansory from "./components/mobile/MobileMansory";

function App(props) {
  //localStorage.removeItem("main_product");

  const [category, setCategory] = useState("");
  const [categories, setCategories] = useState(props.categories)
  const [products, setProducts] = useState([]);
  const [api, setApi] = useState();
  const [reset, setReset] = useState(JSON.parse(localStorage.getItem("main_product")) === null ? true : false)
  const [refresh, setRefresh] = useState(false)
  const [maxPrice, setMaxPrice] = useState(10000)
  const [tags, setTags] = useState(null)
  const [loading, setLoading] = useState(false)

  const windowSize = useRef([window.innerWidth, window.innerHeight])

  const { initFilters, resetState } = useContext(FilterContext)

  const resetApp = () => {
    // console.log('restart')
    localStorage.removeItem("main_product")
    resetState()

    setReset(true)
  }

  useEffect(() => {
    if (props.website && props.public_token)
      setApi(new window.Visidea.Api(props.website, props.public_token));
    setCategory(props.category);
    setCategories(props.categories)
  }, [props]);

  const resetCategory = (cat) => {
    localStorage.removeItem("main_product")
    setCategory(cat)
  }

  const fetchShopProductsByCat = () => {
    // console.log("FETCH BY CATEGORY")
    fetchWebsiteProductsByCat(category)
      .then(res => res.json())
      .then(result => {
        var products = [];
        var filters = [];

        for (var product of result.data.collectionByHandle.products.edges) {
          // console.log(product.node)
          products.push({
            id: product.node.id,
            title: product.node.title,
            price: product.node.priceRange.minVariantPrice.amount,
            image: product.node.featuredImage.src,
            url: product.node.onlineStoreUrl,
            tags: product.node.tags
          });

          filters.push(product.node.tags)
        }

        setProducts(
          products
            .map(value => ({ value, sort: Math.random() }))
            .sort((a, b) => a.sort - b.sort)
            .map(({ value }) => value)
        )
        setMaxPrice(Math.max(...products.map(p => p.price)))

        if (reset || JSON.parse(localStorage.getItem("main_product")) === null) {
          let tags_dict = {}
          // console.log(filters)
          let tags_values = filters.flat().filter(str => str.includes('_') && (str.includes('Material') || str.includes('Technique') || str.includes('Classification') || str.includes('Color')))
          tags_values = [... new Set(tags_values)]

          tags_values.map((tag) => {
            if (tag !== 'Shape') {
              tags_dict[tag] = ''
            }
          })

          setTags(tags_values)

          fetchWebsiteCollections()
            .then(res => res.json())
            .then(result => {
              var categories = [];
              categories.push({ title: 'All categories', handle: 'all-categories' })

              for (var cat of result.data.collections.edges) {
                // console.log(product.node)
                categories.push({
                  id: cat.node.id,
                  title: cat.node.title,
                  handle: cat.node.handle,

                });
              }

              //setCategories(categories)
            })

          initFilters({
            'Price': [0, Math.max(...products.map(p => p.price))],
            'Shape': '',
            'Tags': tags_dict
          })
        }

        setLoading(false)
      });

  }

  const fetchShopProducts = () => {
    // console.log("FETCH NORMAL")
    fetchWebsiteProducts()
      .then(res => res.json())
      .then(result => {
        var products = [];
        var filters = [];

        for (var product of result.data.products.edges) {
          //console.log(product.node)
          products.push({
            id: product.node.id,
            title: product.node.title,
            price: product.node.priceRange.minVariantPrice.amount,
            image: product.node.featuredImage.src,
            url: product.node.onlineStoreUrl,
            tags: product.node.tags
          });

          filters.push(product.node.tags)
        }

        setProducts(
          products
            .map(value => ({ value, sort: Math.random() }))
            .sort((a, b) => a.sort - b.sort)
            .map(({ value }) => value)
        )
        setMaxPrice(Math.max(...products.map(p => p.price)))

        if (reset || JSON.parse(localStorage.getItem("main_product")) === null) {
          let tags_dict = {}
          // console.log(filters)
          let tags_values = filters.flat().filter(str => str.includes('_') && (str.includes('Material') || str.includes('Technique') || str.includes('Classification') || str.includes('Color')))
          tags_values = [... new Set(tags_values)]

          tags_values.map((tag) => {
            if (tag !== 'Shape') {
              tags_dict[tag] = ''
            }
          })

          setTags(tags_values)

          fetchWebsiteCollections()
            .then(res => res.json())
            .then(result => {
              var categories = [];
              categories.push({ title: 'All categories', handle: 'all-categories' })

              for (var cat of result.data.collections.edges) {
                // console.log(product.node)
                categories.push({
                  id: cat.node.id,
                  title: cat.node.title,
                  handle: cat.node.handle,

                });
              }

              //setCategories(categories)
            })

          initFilters({
            'Price': [0, Math.max(...products.map(p => p.price))],
            'Shape': '',
            'Tags': tags_dict
          })
        }

        setLoading(false)
      });
  }

  useEffect(() => {

    if (!refresh) {
      setLoading(true)

      if (category !== "all-categories" && category !== "") {
        fetchShopProductsByCat()
      } else if (category === "all-categories" && category !== "") {
        fetchShopProducts()
      }
    }

    setRefresh(false)

  }, [category, refresh])

  useEffect(() => {
    if (reset) {
      setLoading(true)

      if (category !== "all-categories" && category !== "") {
        fetchShopProductsByCat()
      } else if (category === "all-categories" && category !== "") {
        fetchShopProducts()
      }
    }

    setReset(false)
  }, [reset, category])

  return (
    <div className="App" style={{ backgroundColor: '#f5f5f5' }}>
      {
        isMobile ?
          <MobileFilters
            reset={resetApp}
            refresh={setRefresh}
            maxPrice={maxPrice}
            tags={tags}
            categories={categories}
            resetCategory={resetCategory}
            category={category}
          />
          :
          <Filters
            reset={resetApp}
            refresh={setRefresh}
            maxPrice={maxPrice}
            tags={tags}
            categories={categories}
            resetCategory={resetCategory}
            category={category}
          />
      }
      <div style={{ paddingTop: 25, paddingLeft: isMobile ? 25 : 125, paddingRight: isMobile ? 25 : 125, paddingBottom: 25 }}>
        {
          !loading ?
            JSON.parse(localStorage.getItem("main_product")) === null
              ?
              <ProductsHome products={products} reset={setReset} />
              :
              isMobile && windowSize.current[0] < 700 ?
                <MobileMansory api={api} refresh={refresh} endRefresh={setRefresh} />
                :
                <VsMasonry api={api} refresh={refresh} endRefresh={setRefresh} />
            :
            <></>
        }
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </div>
  );
}

export default App;
